import { render, staticRenderFns } from "./VariantsEditorModal.vue?vue&type=template&id=511cc5c0&scoped=true&"
import script from "./VariantsEditorModal.vue?vue&type=script&lang=js&"
export * from "./VariantsEditorModal.vue?vue&type=script&lang=js&"
import style0 from "./VariantsEditorModal.vue?vue&type=style&index=0&id=511cc5c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511cc5c0",
  null
  
)

export default component.exports